export default function blobToArrayBuffer(blob) {
  const fileReader = new FileReader();

  return new Promise(((resolve, reject) => {
    fileReader.onload = resolve;
    fileReader.onerror = reject;

    fileReader.readAsArrayBuffer(blob);
  }));
}
